module.exports = __webpack_public_path__ + "img/speaker_with_gradient_purple.8cb28e8c.png";